/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProgressiveDateIntervalDto } from './ProgressiveDateIntervalDto';

export type UserProfileDto = {
    firstName: string;
    lastName: string;
    termsAccepted: boolean;
    gender: UserProfileDto.gender;
    dateFlags: Array<ProgressiveDateIntervalDto>;
    isVitalisDemo?: boolean;
    notifiedDoctor?: boolean;
    selfPaid?: boolean;
};

export namespace UserProfileDto {

    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
    }


}

